import React from 'react';
import PropTypes from 'prop-types';

import LanguageConverterV2 from '@careerstart/wae-common/src/main/helperFunction/LanguageConverterV2';
import { Box, Card, CardContent, Typography } from '@mui/material';

import { PRIMARY_PURPLE } from '../../theme/colorConstants';
import { PRIMARY_FONT } from '../../theme/fontConstants';
import { epochToDateInReadableFormat, epochToTimeInReadableFormat } from '../../utils';
import formatAddress from '../../utils/formatAddress';

import KeyValuePair from './KeyValuePair';

const jobHeaderStyle = {
  fontSize: '24px',
  fontFamily: PRIMARY_FONT[700],
  marginBottom: '16px',
};

const staffingContainerStyle = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: { xs: '12px 16px', md: '24px' },
  marginTop: '24px',
};

const JobInformationCard = ({ jobOrder }) => {
  const jobLocation = jobOrder?.location;
  const remainingOpenings = (jobOrder?.numOpenings || 0) - (jobOrder?.numFilled || 0);

  return (
    <Card sx={{ boxShadow: 'none' }} elevation={0}>
      <CardContent sx={{ padding: '16px' }}>
        <Typography sx={jobHeaderStyle}>
          {LanguageConverterV2('dashboard.recommendWorkerModal.jobInformation')}
        </Typography>

        {/* Job Details Section */}
        <Box sx={{ marginBottom: '20px' }}>
          <KeyValuePair
            name={LanguageConverterV2('dashboard.recommendWorkerModal.position')}
            value={jobOrder?.name || 'N/A'}
          />

          <KeyValuePair
            name={LanguageConverterV2('dashboard.recommendWorkerModal.date')}
            value={epochToDateInReadableFormat(jobOrder?.start) || 'N/A'}
          />

          <KeyValuePair
            name={LanguageConverterV2('dashboard.recommendWorkerModal.shiftTime')}
            value={
              jobOrder?.start && jobOrder?.end
                ? `${epochToTimeInReadableFormat(jobOrder.start)}-${epochToTimeInReadableFormat(
                    jobOrder.end
                  )}`
                : 'N/A'
            }
          />

          <KeyValuePair
            name={LanguageConverterV2('dashboard.recommendWorkerModal.address')}
            value={jobLocation ? formatAddress(jobLocation) : 'N/A'}
          />
        </Box>

        {/* Staffing Summary Section */}
        <Box sx={staffingContainerStyle}>
          <KeyValuePair
            name={LanguageConverterV2('dashboard.recommendWorkerModal.totalNeeds')}
            value={jobOrder?.numOpenings || 0}
          />

          <KeyValuePair
            name={LanguageConverterV2('dashboard.recommendWorkerModal.placements')}
            value={jobOrder?.numFilled || 0}
          />

          <KeyValuePair
            name={LanguageConverterV2('dashboard.recommendWorkerModal.remainingOpenings')}
            value={remainingOpenings}
            keyColor={PRIMARY_PURPLE[70]}
            valueColor={PRIMARY_PURPLE[70]}
          />
        </Box>
      </CardContent>
    </Card>
  );
};

JobInformationCard.propTypes = {
  jobOrder: PropTypes.shape({
    name: PropTypes.string,
    start: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    end: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    location: PropTypes.shape({
      address: PropTypes.string,
      city: PropTypes.string,
      state: PropTypes.string,
      zipCode: PropTypes.string,
      country: PropTypes.string,
    }),
    numOpenings: PropTypes.number,
    numFilled: PropTypes.number,
  }),
};

export default JobInformationCard;
